import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { when } from "@/common/directives/when";
import styles from "@/index.css?inline";
import EkoElement from "@/utilities/element";
import style from "./link.css?inline";

@customElement("eko-link")
class Link extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(styles), unsafeCSS(style)];

  @property({ reflect: true, type: Boolean })
  download = false;

  @property({ reflect: true })
  href?: string;

  @property()
  target?: "_self" | "_blank" | "_parent" | "_top";

  @property({ type: String, attribute: "data-turbo-action" }) turboAction?: string;
  @property({ type: String, attribute: "data-turbo-confirm" }) turboConfirm?: string;
  @property({ type: String, attribute: "data-turbo-frame" }) turboFrame?: string;
  @property({ type: String, attribute: "data-turbo-method" }) turboMethod?: string;

  @property({ reflect: true, type: Boolean })
  underline = false;

  @property()
  weight: "inherit" | "normal" | "medium" | "semibold" | "bold" = "inherit";

  render() {
    return html`
      <a
        class="eko-link"
        part="root"
        href=${when(this.href)}
        rel=${when(this.target === "_blank", "noopener noreferrer")}
        target=${ifDefined(this.target)}
        data-turbo-action=${when(this.turboAction)}
        data-turbo-confirm=${when(this.turboConfirm)}
        data-turbo-frame=${when(this.turboFrame)}
        data-turbo-method=${when(this.turboMethod)}
        weight=${this.weight}
        ?download=${this.download}
        ?underline=${this.underline}>
        <slot></slot>
      </a>
    `;
  }
}

export default Link;
